module.exports = __webpack_public_path__ + "media/src/web/images/logo-pink-fd436dc4a3a5a8f1b162dba84dc49a15.webp";